/**
 * @fileoverview Profile modal "Security" tab.
 * @description Two sections: Change Password (the existing ChangePasswordForm, POST
 * /identity/password/change — a successful change signs the user out everywhere) and the active
 * sessions list. ChangePasswordForm owns its own resettable form/mutation state and the whole tab
 * is unmounted when the modal closes or the user switches tabs, so every visit starts clean.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useTranslation } from 'react-i18next'

import ChangePasswordForm from '@/features/auth/components/ChangePasswordForm'
import ProfileSessionsList from '@/features/auth/components/ProfileSessionsList'
import DetailSectionHeading from '@/shared/components/molecules/DetailSectionHeading'

/**
 * @component
 */
function ProfileSecurityTab() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6">
      <section className="flex flex-col gap-3">
        <DetailSectionHeading>{t('profile.security.changePasswordTitle')}</DetailSectionHeading>
        <p className="text-compact-sm text-slate">{t('profile.security.changePasswordHint')}</p>
        <ChangePasswordForm testIdPrefix="profile-change-password" />
      </section>

      <div className="border-t border-divider pt-5">
        <ProfileSessionsList />
      </div>
    </div>
  )
}

export default ProfileSecurityTab
